import { Text } from '@/components/text';
import { TRANSFER_MODE } from '@/lib/constants';
import { DATA_IMAGES } from '@/lib/constants/styles';
import { SegmentTransferModel } from '@/lib/models/segment/types';
import { SegmentModeType } from '@/types/api-types';
import { covertModeToVehicle, formatDuration } from '@/utils/format';
import { tv } from '@/utils/styles';

interface DirectionsTransferProps {
  segment: SegmentTransferModel;
  nextMode: SegmentModeType;
}

const DirectionsTransfer = ({ segment, nextMode }: DirectionsTransferProps) => {
  // Get first option in list to display
  const { durationSeconds } = segment;
  const vehicleType = covertModeToVehicle(nextMode);
  const isModeChange = segment.transferType === TRANSFER_MODE;

  const { edgeRow, row, subText, dot } = styles();

  return isModeChange ? (
    <div className={edgeRow()} style={{ backgroundImage: `url(${DATA_IMAGES.STRIPED_LIGHT})` }}>
      <div className={dot()} />
      <div className="pl-8">
        <Text className={subText()}>Transfer to {vehicleType}</Text>
      </div>
      <p className={subText()}>Approx {formatDuration(durationSeconds)}</p>
    </div>
  ) : (
    <div className={row()}>
      <div className={dot()} />
      <div className="pl-8">
        <Text className={subText()}>Transfer</Text>
      </div>
      <p className={subText()}>Approx {formatDuration(durationSeconds)}</p>
    </div>
  );
};

const styles = tv({
  slots: {
    edgeRow:
      'relative grid grid-cols-[1fr_0.5fr] items-center !bg-grey-100 bg-[length:4px] bg-repeat px-4 py-2 leading-snug md:grid-cols-[var(--route-card-grid-cols-md)] xl:grid-cols-[var(--route-card-grid-cols-xl)]',
    row: 'relative -my-1 mx-0 grid grid-cols-[1fr_0.5fr] items-center px-4 py-0 leading-snug md:grid-cols-[var(--route-card-grid-cols-md)] xl:grid-cols-[var(--route-card-grid-cols-xl)]',
    subText: 'm-0 text-sm text-text-secondary',
    dot: 'absolute left-[22px] top-1/2 h-2 w-2 -translate-y-1/2 transform rounded-full bg-grey-300',
  },
});

export { DirectionsTransfer };
